Controller.$inject = ['$timeout'];

function Controller($timeout) {
    const self = this;
    self.showLegend = false;
    self.inputFocused = false;

    self.handleFocus = () => {
        if (self.labelVariant === 'outlined') {
            self.showLegend = true;
            self.inputFocused = true;
        }
    };

    self.handleBlur = () => {
        if (!self.ngModel) {
            self.showLegend = false;
        }
        self.inputFocused = false;

        if (self.blurEvent) {
            self.blurEvent();
        }
    };

    self.handleChange = ($event) => {
        $timeout(() => {
            self.onChange({$event});
        });
    };

    self.selectedSwitcherChange = (value) => {
        self.switcherChanged({ value });
    };

    self.onStepDown = () => {
        if (self.disabled) {
            return;
        }

        const step = self.step ? self.step : 1;
        const newValue = self.ngModel - step;

        self.ngModel = self.min !== undefined ? Math.max(newValue, self.min) : newValue;
    };

    self.onStepUp = () => {
        if (self.disabled) {
            return;
        }

        const step = self.step ? self.step : 1;
        const newValue = self.ngModel + step;

        self.ngModel = self.max !== undefined ? Math.min(newValue, self.max) : newValue;
    };
}

export function HuiInputNumber() {
    return {
        restrict: 'E',
        scope: true,
        bindToController: {
            ngModel: '=',
            labelVariant: '@',
            iconPosition: '@',
            disabled: '<',
            hName: '@',
            hasError: '<',
            placeholder: '@',
            onChange: '&',
            blurEvent: '&',
            fullWidth: '<',
            sizing: '<?',
            selectorType: '@',
            min: '<?',
            max: '<?',
            step: '<?',
            switcherOptions: '<?',
            switcherChanged: '&',
        },
        controller: Controller,
        controllerAs: '$huiCtrl',
        transclude: {
            label: '?huiInputLabel',
            icon: '?huiInputIcon',
            addonStart: '?huiInputAddonStart',
            addonEnd: '?huiInputAddonEnd'
        },
        template: ($element, $attrs) => {
            return `
              <hui-input-base
                label-variant="{{$huiCtrl.labelVariant}}"
                selector-type="{{$huiCtrl.selectorType}}"
                icon-position="{{$huiCtrl.iconPosition || 'start'}}"
                has-error="$huiCtrl.hasError"
                show-legend="$huiCtrl.showLegend"
                input-focused="$huiCtrl.inputFocused"
                model-value="$huiCtrl.ngModel"
                disabled="$huiCtrl.disabled"
                full-width="$huiCtrl.fullWidth"
                sizing="$huiCtrl.sizing"
                on-step-up="$huiCtrl.onStepUp()"
                on-step-down="$huiCtrl.onStepDown()"
                switcher-options="$huiCtrl.switcherOptions"
                on-selected-switcher-change="$huiCtrl.selectedSwitcherChange($event)"
                >
                <hui-input-base-start-addon ng-transclude ng-transclude-slot="addonStart" class="h-100"></hui-input-base-start-addon>
                <hui-input-base-end-addon ng-transclude ng-transclude-slot="addonEnd" class="h-100"></hui-input-base-end-addon>
                <hui-input-base-label ng-transclude ng-transclude-slot="label"></hui-input-base-label>
                <hui-input-base-icon ng-transclude ng-transclude-slot="icon"></hui-input-base-icon>
                    <input type="number"
                           ng-model="$huiCtrl.ngModel"
                           ng-disabled="$huiCtrl.disabled"
                           placeholder="{{$huiCtrl.labelVariant !== 'outlined' ? $huiCtrl.placeholder : ''}}"
                           name="{{$huiCtrl.hName}}"
                           min="{{$huiCtrl.min}}"
                           max="{{$huiCtrl.max}}"
                           step="{{$huiCtrl.step}}"
                           class="hui-base-input"
                           ng-focus="$huiCtrl.handleFocus()"
                           ng-blur="$huiCtrl.handleBlur()"
                           ng-change="$huiCtrl.handleChange($event)"/>
              </hui-input-base>
             `;
        }
    }
}

